export type TypewriterFrame = {
  phraseIndex: number;
  charCount: number;
  delayMs: number;
};

export type TypewriterTiming = {
  typeIntervalMs: number;
  holdMs: number;
  eraseIntervalMs: number;
};

export function* typewriterFrames(
  phrases: string[],
  timing: TypewriterTiming
): Generator<TypewriterFrame> {
  if (phrases.length === 0) return;

  let phraseIndex = 0;
  while (true) {
    const word = phrases[phraseIndex] ?? '';

    for (let charCount = 1; charCount <= word.length; charCount++) {
      const isFinalChar = charCount === word.length;
      yield {
        phraseIndex,
        charCount,
        delayMs: isFinalChar ? timing.holdMs : timing.typeIntervalMs,
      };
    }

    for (let charCount = word.length - 1; charCount >= 0; charCount--) {
      yield { phraseIndex, charCount, delayMs: timing.eraseIntervalMs };
    }

    phraseIndex = (phraseIndex + 1) % phrases.length;
  }
}
